/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitionWithRelations } from '../../models/exhibition-with-relations';

export interface InventoryGetExhibitions$Params {
  inventoryId: string;
}

export function inventoryGetExhibitions(http: HttpClient, rootUrl: string, params: InventoryGetExhibitions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExhibitionWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, inventoryGetExhibitions.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExhibitionWithRelations>>;
    })
  );
}

inventoryGetExhibitions.PATH = '/inventory/exhibitions';
